import { render } from "./Support.vue?vue&type=template&id=5ddceec9&scoped=true"
import script from "./Support.vue?vue&type=script&lang=js"
export * from "./Support.vue?vue&type=script&lang=js"

import "./Support.vue?vue&type=style&index=0&id=5ddceec9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ddceec9"]])

export default __exports__